<template id="loadingTmpl" >
	
	<div class="text-xs-center">
		<v-overlay v-model="$root.simpleLoadingGuard" z-index="1000">
			<v-card color="primary">
				<v-card-text>
					{{$t('lbl.wait')}}<v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-overlay>

		<v-overlay v-model="$root.globalLoadingGuard" z-index="1000">
			<v-card color="primary">
				<v-card-text>
					{{$t('lbl.waitCompletePage')}}<v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-overlay>
	</div>
</template>
<script>
module.exports = {
  
};
</script>